<template>
  <div class="opc-global-error__config">
    <div class="opc-global-error__config-title">
      <Nav />
    </div>
    <tile>
      <zm-skeleton :rows="12" />
    </tile>
    <div class="opc-global-error__config-addon">
      <zm-skeleton :rows="1" style="margin-bottom: 24px; height: 24px;" />
      <tile v-for="item in addonList" :key="item">
        <zm-skeleton :rows="3" />
      </tile>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/nav';
import Tile from '@/components/tile';

export default {
  name: 'ErrorConfig',
  components: {
    Nav,
    Tile,
  },
  data() {
    return {
      addonList: new Array(3),
    };
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-global-error__config {
  width: 100%;

  &-title {
    margin-bottom: 48px;
    @include media(mobile, tablet) {
      margin-bottom: $mobile-space;
    }
  }

  &-addon {
    margin-top: 48px;
    padding-top: 48px;
    border-top: 2px solid #dfe3e8;
  }
}
</style>
